/**
 * 拼接管理端静态资源/图片完整 URL，避免 BASEURL 尾斜杠 + 路径首斜杠变成 // 导致 404
 */
export function joinMediaUrl(path) {
  const raw = path == null ? '' : String(path).trim()
  if (!raw) return ''
  if (/^https?:\/\//i.test(raw) || raw.startsWith('data:')) return raw
  const base = String(process.env.VUE_APP_BASEURL || '')
    .trim()
    .replace(/\/+$/, '')
  const rel = raw.startsWith('/') ? raw : `/${raw}`
  return base ? `${base}${rel}` : rel
}
